import React, { useEffect } from 'react';
import { PageHeader, Tabs } from 'antd';

import CodeHighlight from 'code-highlight';

// import all the styles
import "code-highlight/lib/style.css";
import "highlight.js/styles/github-gist.css";

import * as IMI from '../../lib/ManiaFrameWork/js/mania';

const { TabPane } = Tabs;
const routes = [
  {
    path: '/',
    breadcrumbName: 'Displays',
  },
  {
    path: 'Tooltip',
    breadcrumbName: 'Tooltip',
  },
];

const Tooltip_Component = () => {
  useEffect(() => document.querySelectorAll('[data-rule="tooltip"]').forEach((el) => new IMI.Tooltip(el)), []);
  return (
    <>
      <PageHeader title="Tooltip" breadcrumb={{ routes }} subTitle="Tooltip" style={{ padding: 10 }} />

      <div className="MF_area">
        <button className="btn btn_blue" data-rule="tooltip" data-target="#tooltip_box">Mouse over</button>
        <div className="tooltip_box" id="tooltip_box">
          <div className="cont">
            Tootip Contents!
          </div>
        </div>
      </div>
      <div className="codeArea">
        <Tabs defaultActiveKey="1">
          <TabPane tab="HTML" key="1">
            <CodeHighlight language="HTML">
              {`<button class="btn btn_blue" data-rule="tooltip" data-target="#tooltip_box">InfoBox</button>
<div class="tooltip_box" id="tooltip_box">
  <div class="cont">
    Tootip Contents!
  </div>
</div>`}
            </CodeHighlight>
          </TabPane>
          <TabPane tab="JAVASCRIPT" key="2">
            <CodeHighlight language="JS">
              {`var tooltips = document.querySelectorAll('[data-rule="tooltip"]');
for (var i = 0; i < tooltips.length; i++){ new Tooltip(tooltips[i]) }`}
            </CodeHighlight>
          </TabPane>
        </Tabs>
      </div>


    </>
  );
}

export default Tooltip_Component;
